// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__41Cxn","inputDescription":"styles_inputDescription__SGHMe"};